import { styled } from 'styled-components'
import Popup from 'common-components/Popup'
import { Text } from 'common-components'

export const FullStoragePopup = styled(Popup)`
  .popup-content {
    padding: 48px 48px 24px 48px;
    border-radius: 16px;
  }
`

export const FullStorageWarningContainer = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`

export const FullStorageImage = styled.img`
  width: 160px;
  height: 105px;
`

export const WarningDescription = styled(Text)`
  max-width: 340px;
`
